<ng-container *ngIf="isLoaded">
  <iframe
  #onboardingFrame      
    (load)="onIframeLoad()"
    [src]="(iframeSrc || onboardingUrl) | safeUrl"
    height="100%"
    loading="eager"
    width="100%"
    allowFullScreen
    title="Dashboard"
  ></iframe>
</ng-container>
